import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { FileUploadField } from '@unite-us/app-components';
import ContactDocumentsSelector from './ContactDocumentsSelector';
import DocumentVisibility from './DocumentVisibility';

class UploadAndAttachDocumentsFormFields extends PureComponent {
  handleFilesChange = (files) => {
    const { fields } = this.props;
    fields.uploadedDocuments.onChange(files);
  };

  render() {
    const {
      dropzoneName,
      fields,
      formIndex,
      persistOnUnmount,
      registerField,
      warningText,
      showDocumentVisibility,
      hasSocialCareNavigationRole,
    } = this.props;

    return (
      <div className="upload-and-attach-documents-form-fields">
        <ContactDocumentsSelector
          formIndex={formIndex}
          documentFields={fields.attachableDocuments}
        />

        <FileUploadField
          ref={registerField}
          dropzoneName={dropzoneName}
          onFilesChange={this.handleFilesChange}
          persistOnUnmount={persistOnUnmount}
          maxFiles={30}
          warningText={warningText}
        />

        {showDocumentVisibility && (
          <DocumentVisibility
            privateToOrg={fields.privateToOrg}
            privateToRole={fields.privateToRole}
            hasSocialCareNavigationRole={hasSocialCareNavigationRole}
          />
        )}
      </div>
    );
  }
}

UploadAndAttachDocumentsFormFields.propTypes = {
  dropzoneName: PropTypes.string.isRequired,
  fields: PropTypes.shape({
    attachableDocuments: PropTypes.array,
    uploadedDocuments: PropTypes.object,
    privateToOrg: PropTypes.bool,
    privateToRole: PropTypes.bool,
  }).isRequired,
  formIndex: PropTypes.number,
  persistOnUnmount: PropTypes.bool,
  registerField: PropTypes.func.isRequired,
  warningText: PropTypes.string,
  showDocumentVisibility: PropTypes.bool,
  hasSocialCareNavigationRole: PropTypes.bool,
};

UploadAndAttachDocumentsFormFields.defaultProps = {
  persistOnUnmount: false,
  formIndex: undefined,
  warningText: undefined,
  showDocumentVisibility: false,
  hasSocialCareNavigationRole: false,
};

export default UploadAndAttachDocumentsFormFields;
